
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export const spinner = reactElement("div", createObj(ofArray([["className", "spinner-grow .spinner ml-auto mr-auto mt-auto mb-auto"], ["role", join(" ", ["status"])], (() => {
    const elems = [reactElement("span", {
        className: "sr-only",
        children: "Loading ...",
    })];
    return ["children", reactApi.Children.toArray(Array.from(elems))];
})()])));

